import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

type selectedCategoryType = {
  major_category_id: number;
  sub_category_id: number;
};

// status: 0: not, 1: 검수중 2: 광고중 3: 반려됨
const testData = [
  {
    hotel_id: 0,
    hotel_name: '노크호텔',
    status: 0,
    device_num: 96,
  },
  {
    hotel_id: 1,
    hotel_name: '녹녹호텔',
    status: 1,
    device_num: 180,
  },
  {
    hotel_id: 2,
    hotel_name: '스루모텔',
    status: 2,
    device_num: 300,
  },
  {
    hotel_id: 3,
    hotel_name: '비하인드호텔',
    status: 3,
    device_num: 200,
  },
  {
    hotel_id: 4,
    hotel_name: '포스모텔',
    status: 3,
    device_num: 540,
  },
  {
    hotel_id: 5,
    hotel_name: '키오스크여관',
    status: 1,
    device_num: 200,
  },
  {
    hotel_id: 6,
    hotel_name: 'The kds',
    status: 2,
    device_num: 100,
  },
  {
    hotel_id: 7,
    hotel_name: 'kpi호텔',
    status: 0,
    device_num: 200,
  },
  {
    hotel_id: 8,
    hotel_name: '관리자모텔',
    status: 0,
    device_num: 200,
  },
  {
    hotel_id: 9,
    hotel_name: '오운호텔',
    status: 3,
    device_num: 124,
  },
  {
    hotel_id: 10,
    hotel_name: '이름못정하겠다',
    status: 0,
    device_num: 76,
  },
];

const AdvertiseStatus = () => {
  const [selectedList, setSelectedList] = useState<any>([]);
  const [advertisingList, setAdvertisingList] = useState<any>([]);
  const [adDeviceCount, setAdDeviceCount] = useState<number>(0);
  const [notAdDeviceCount, setNotAdDeviceCount] = useState<number>(0);
  const [isAdOpen, setIsAdOpen] = useState<boolean>(false);
  const [isSelectedOpen, setIsSelectedOpen] = useState<boolean>(false);

  const onChangeCheckbox = (item: any) => {
    if (selectedList.includes(item)) {
      const updatedList = selectedList.filter((source: any) => source.hotel_id !== item.hotel_id);
      setSelectedList(updatedList);
      setNotAdDeviceCount(notAdDeviceCount - item.device_num);
    } else {
      setSelectedList([...selectedList, item]);
      setNotAdDeviceCount(notAdDeviceCount + item.device_num);
    }
  };

  useEffect(() => {
    let deviceCount = 0;
    let listTemp: any = [];
    testData.map((item: any) => {
      if (item.status === 2) {
        listTemp.push(item);
        deviceCount += item.device_num;
      }
    });
    setAdvertisingList([...listTemp]);
    setAdDeviceCount(deviceCount);
  }, []);

  return (
    <>
      <Style>
        <div className="contentContainer">
          <div className="titleBadge">
            <h4>우리 매장 광고현황</h4>
          </div>
          <div className="warningSign">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
            <p>멀티매장일 경우, 각 매장별로 광고 노출 현황을 확인해주세요</p>
          </div>
          <div className="listWrap">
            {testData.map((item: any, index: number) => {
              return (
                item.status !== 0 && (
                  <div className="listItem" key={index}>
                    <div
                      className={`statusBadge ${item.status === 1 && 'check'} ${
                        item.status === 2 && 'ad'
                      } ${item.status === 3 && 'reject'} `}>
                      <h5>
                        {item.status === 1 ? '검수중' : item.status === 2 ? '광고중' : '반려됨'}
                      </h5>
                    </div>
                    <img
                      className="titleImg"
                      src={`${process.env.PUBLIC_URL}/img/hotel0${(index % 7) + 1}.png`}
                      alt="img"
                    />
                    <h4>{item.hotel_name}</h4>
                    <h5>기기 수 {item.device_num}개</h5>
                  </div>
                )
              );
            })}
          </div>
          <div className="titleBadge">
            <h4>추가 광고 가능한 호텔</h4>
          </div>
          <div className="listWrap">
            {testData.map((item: any, index: number) => {
              return (
                item.status === 0 && (
                  <div className="listItem" key={index}>
                    <label
                      htmlFor={`check${index}`}
                      className={`checkbox ${selectedList.includes(item) && 'checked'}`}>
                      <img src={`${process.env.PUBLIC_URL}/svg/ic_check.svg`} alt="ic" />
                    </label>
                    <input
                      type="checkbox"
                      id={`check${index}`}
                      value={item}
                      checked={selectedList.includes(item)}
                      onChange={(e) => onChangeCheckbox(item)}
                    />
                    <img
                      className="titleImg"
                      src={`${process.env.PUBLIC_URL}/img/hotel0${(index % 7) + 1}.png`}
                      alt="img"
                    />
                    <h4>{item.hotel_name}</h4>
                    <h5>기기 수 {item.device_num}개</h5>
                  </div>
                )
              );
            })}
          </div>
        </div>

        <div className="contentContainer">
          <div className="infoTitle">
            <h4>광고 이용료 안내</h4>
            <div className="eventBadge">
              <img src={`${process.env.PUBLIC_URL}/svg/ic_event.svg`} alt="ic" />
              <p>90일 체험 EVENT 이용 가능</p>
            </div>
          </div>
          <div className="infoContent title">
            <h4>현재 광고 중</h4>
          </div>
          <div className="infoContent">
            <div className="row between">
              <h5>호텔 수</h5>
              <h5>{testData.filter((item) => item.status === 2).length}개</h5>
            </div>
            <div className="row between">
              <h5>기기 수</h5>
              <h5>{adDeviceCount}개</h5>
            </div>
            <div className="row center" onClick={() => setIsAdOpen(!isAdOpen)}>
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_arrow_${isAdOpen ? 'up' : 'down'}_grey.svg`}
                width={28}
                height={28}
                alt="ic"
              />
            </div>
          </div>
          {isAdOpen && (
            <div className="infoContent grey">
              {advertisingList.map((item: any, index: number) => {
                return (
                  <div className="row between" key={index}>
                    <h5>{item.hotel_name}</h5>
                    <h5>기기수 {item.device_num}개</h5>
                  </div>
                );
              })}
            </div>
          )}

          <div className="infoContent title">
            <h4>추가 광고</h4>
          </div>
          <div className="infoContent">
            <div className="row between">
              <h5>호텔 수</h5>
              <h5>{selectedList.length}개</h5>
            </div>
            <div className="row between">
              <h5>기기 수</h5>
              <h5>{notAdDeviceCount}개</h5>
            </div>
            <div className="row center" onClick={() => setIsSelectedOpen(!isSelectedOpen)}>
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_arrow_${
                  isSelectedOpen ? 'up' : 'down'
                }_grey.svg`}
                width={28}
                height={28}
                alt="ic"
              />
            </div>
          </div>
          {isSelectedOpen && (
            <div className="infoContent grey">
              {selectedList.map((item: any, index: number) => {
                return (
                  <div className="row between" key={index}>
                    <h5>{item.hotel_name}</h5>
                    <h5>기기수 {item.device_num}개</h5>
                  </div>
                );
              })}
            </div>
          )}
          <div className="infoContent bottom">
            <div className="row between">
              <h3>누적 광고 이용료</h3>
              <div className="alignRight">
                <h3>{((adDeviceCount + notAdDeviceCount) * 450).toLocaleString()}원</h3>
                <p>다음 청구일&nbsp;&nbsp;&nbsp;23 / 12 / 10</p>
              </div>
            </div>
          </div>
          <div className="warningSign">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
            <p>
              광고료 산정 기준은 기기 200개당 월 90,000원. 광고 이용료는 광고시작일이 속한 달의
              일수로 일할계산됩니다 90일 체험하기는 사용 이력이 없을 경우 자동으로 적용되며,
              체험광고 기기 수에 상관 없이 노출일 수로 제한됩니다
            </p>
          </div>
          <button className={`submitButton`}>광고 검수 신청하기</button>

          {/* <button className="testButton">
            <div className="eventBadge">
              <p>EVENT</p>
            </div>
            90일 무료 체험하기
          </button>
          <div className="warningSign">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
            <p>90일 체험하기는 광고 기기 수에 상관 없이 노출일 수로 제한됩니다</p>
          </div> */}
        </div>
      </Style>
    </>
  );
};

export default AdvertiseStatus;

const Style = styled.div`
  .contentContainer:nth-child(1) {
    border-radius: 10px 10px 0 0;
    padding-bottom: 27px;
  }
  .contentContainer:nth-child(2) {
    padding-top: 60px;
    border-radius: 0 0 10px 10px;
  }

  .titleBadge {
    padding: 8px 25px;
    background: #ecf5f3;
    border-radius: 5px;
    h4 {
      color: #555555;
    }
  }

  .infoTitle {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 9px 36px;
    background: #40977f;
    border-radius: 5px 5px 0 0;
    h4 {
      color: #ffffff;
    }
  }
  .infoContent {
    border: 1px solid #e5e5e5;
    border-top: none;
    border-bottom: 1px solid #f0f0f0;
    padding: 16px 36px;
    padding-bottom: 0;

    h4 {
      font-weight: 500;
      color: #40977f;
    }
    h5 {
      padding: 6px 0;
      font-size: 16px;
      line-height: 22px;
      color: #4d4d4d;
    }
    img {
      margin-top: -12px;
    }
  }
  .infoContent.title {
    padding: 8px 36px;
  }
  .infoContent.grey {
    margin-top: -1px;
    padding: 8px 36px;
    background: #f7f7f7;

    h5 {
      padding: 6px 0;
      color: #979797;
    }
  }
  .infoContent.bottom {
    background: #ecf5f3;
    padding: 24px 36px;
    border-bottom: 1px solid #e5e5e5;
    border-radius: 0 0 5px 5px;
    .alignRight {
      text-align: right;
    }
    h3 {
      font-weight: 600;
      color: #40977f;
    }
    p {
      font-weight: 400;
      color: #a7a7a7;
    }
  }

  .listWrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    padding-top: 30px;
  }
  .listItem {
    flex-basis: calc(25% - 6px);
    position: relative;
    padding-bottom: 30px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    h4 {
      color: #555555;
      font-weight: 600;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    h5 {
      color: #a7a7a7;
    }
    .titleImg {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      object-fit: cover;
    }
    .statusBadge {
      position: absolute;
      top: 0;
      right: 0;
      border-radius: 0px 5px 0px 5px;
      padding: 3px 10px;
      h5 {
        color: #ffffff;
        font-weight: 600;
      }
    }
    .statusBadge.ad {
      background: #ff6060;
    }
    .statusBadge.check {
      background: #ff8f0b;
    }
    .statusBadge.reject {
      background: #a7a7a7;
    }

    input[type='checkbox'] {
      display: none;
    }
    .checkbox {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 34px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 0px 5px 0px 5px;
    }
    .checkbox.checked {
      background: #40977f;
    }
  }

  .submitButton {
    margin-bottom: 24px;
    font-weight: 700;
  }

  .eventBadge {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 2px 16px;
    border-radius: 50px;
    background: #ff6060;
    p {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .testButton {
    position: relative;
    width: 100%;
    background: #ffffff;
    padding: 12px 0 !important;
    color: #4dd2ae;
    border: 1px solid #4dd2ae;
    outline: none;
    border-radius: 8px;
    font-size: 20px;
    line-height: 28px;
    font-weight: 700;
  }
`;
